import { styled } from "@mui/material/styles";
import TableHead from "@mui/material/TableHead";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#1E59A7",
        color: "#fff",
        padding: "10px 6px",
        borderRight: "1px solid rgba(255, 255, 255, 0.1);",
        fontSize: "12px",
    },
    [`&.${tableCellClasses.head}:last-child`]: {
        borderRight: 0,
    },
}));

const CommonTableHeaderRow = (props) => {
    const { columnDefs, handleSorting } = props
    return (
        <TableHead>
            <TableRow>
                {columnDefs && columnDefs.map((col, index) => (
                    !col.isHidden && <StyledTableCell style={col.headerSx} key={`th-col-${col.field}-${index}`}>
                        <span> {col.headerName}</span>
                        {col.allowSorting && (
                            <span className="sortingIcon">
                                <span className="up" onClick={(e) => handleSorting(e, col.field, 'asc')}>
                                    <FontAwesomeIcon icon={faCaretUp} transform="shrink-2" pointerEvents={"none"} />
                                </span>
                                <span className="down" onClick={(e) => handleSorting(e, col.field, 'desc')}>
                                    <FontAwesomeIcon icon={faCaretDown} transform="shrink-2" pointerEvents={"none"} />
                                </span>
                            </span>
                        )}
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead >
    )
}

export default CommonTableHeaderRow;